import styled from 'styled-components'

import {containerMixin} from '../../cssMixins/container'

export const Container = styled.div`
  ${p => containerMixin(p.width)};
`
